import Text from 'components/core/Text';
import Link from 'next/link';
import { FC, useMemo } from 'react';

import { Program, Session } from 'reducers/programs/types';
import imageUrlGenerator from 'utils/imageUrlGenerator';
import {
  SessionNavigationItemLink,
  SessionNavigationItemContent,
  SessionNavigationItemPicture,
  SessionNavigationWrapper,
} from './styles';

interface Props {
  nextSession?: Session;
  prevSession?: Session;
  program?: Program;
  nextTrackSessionId?: number;
  prevTrackSessionId?: number;
}

const SessionNavigationItem = ({
  session,
  program,
  isPrevious,
  trackSessionId,
}: {
  session?: Session;
  program?: Program;
  isPrevious?: boolean;
  trackSessionId?: number;
}) => {
  const sessionLink = useMemo(() => {
    const baseLink = `/programs/${program?.id}/sessions/${session?.id}`;
    return trackSessionId ? `${baseLink}?trackSessionId=${trackSessionId}` : baseLink;
  }, [session, program, trackSessionId]);

  if (!session) return null;

  return (
    <Link href={sessionLink}>
      <SessionNavigationItemLink href={sessionLink}>
        <SessionNavigationItemPicture
          src={imageUrlGenerator(session?.picture, '860x480', '860x480')}
        />
        <SessionNavigationItemContent isPrevious={isPrevious}>
          <Text variant="sectionHeader" mb={1}>
            {session?.name}
          </Text>
          <Text variant="captionSmall">{isPrevious ? 'Previous' : 'Next'} session</Text>
        </SessionNavigationItemContent>
      </SessionNavigationItemLink>
    </Link>
  );
};

const SessionNavigation: FC<Props> = ({
  nextSession,
  prevSession,
  program,
  nextTrackSessionId,
  prevTrackSessionId,
}) => {
  return (
    <SessionNavigationWrapper>
      <SessionNavigationItem
        session={prevSession}
        program={program}
        isPrevious
        trackSessionId={prevTrackSessionId}
      />
      <SessionNavigationItem
        session={nextSession}
        program={program}
        trackSessionId={nextTrackSessionId}
      />
    </SessionNavigationWrapper>
  );
};

export default SessionNavigation;
